var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddExistingUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "User",
    d: "M12.269,5.733A2.27,2.27,0,1,1,10,3.5,2.251,2.251,0,0,1,12.269,5.733Zm1.5,0A3.769,3.769,0,1,1,10,2,3.751,3.751,0,0,1,13.769,5.733Zm-5.306,6.3h3.073A4.081,4.081,0,0,1,15.5,16.222a.311.311,0,0,1-.082.218.17.17,0,0,1-.125.06H4.707a.17.17,0,0,1-.125-.06.311.311,0,0,1-.082-.218A4.081,4.081,0,0,1,8.463,12.033ZM3,16.222a5.58,5.58,0,0,1,5.463-5.689h3.073A5.58,5.58,0,0,1,17,16.222,1.744,1.744,0,0,1,15.293,18H4.707A1.744,1.744,0,0,1,3,16.222Z",
    transform: "translate(-3 -2)",
    fill: "#333",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddExistingUser);
export default __webpack_public_path__ + "static/media/add-existing-user.79e85ecf6317138d2874865a734be645.svg";
export { ForwardRef as ReactComponent };